import { TFunction } from '@lyearn/i18n';
import { Hash, StarOutline } from '@lyearn/icons';
import { DatabaseRatingTypeEnum } from '@/types/schema';

import { RatingStyleItemType } from './types';

export const getRatingStyleItems = (t: TFunction): RatingStyleItemType[] => [
  {
    Icon: StarOutline,
    label: t('Database:RatingStyles.Stars'),
    value: DatabaseRatingTypeEnum.Star,
  },
  {
    Icon: Hash,
    label: t('Database:RatingStyles.Numbers'),
    value: DatabaseRatingTypeEnum.Number,
  },
];
